const updates = [
  { date: '2026-07-31', label: '资源更新', text: '新增《星际穿越2》《反恐行动》等12部高清电影，全集蓝光画质不缓冲秒开。' },
  { date: '2026-07-30', label: '剧集上线', text: '热播剧《长安十二时辰第二季》全36集上线，高清不卡顿免费在线观看。' },
  { date: '2026-07-29', label: '系统优化', text: '播放器全面升级，智能码率自适应更精准，移动端加载速度提升40%。' },
  { date: '2026-07-28', label: '片库扩展', text: '韩剧频道新增《信号3》《黑暗荣耀》等20部高分韩剧，中文字幕同步更新。' },
  { date: '2026-07-27', label: '功能上线', text: 'APP客户端新增离线缓存功能，支持提前下载高清影片，无网络也能流畅观看。' },
  { date: '2026-07-26', label: '资源更新', text: '暑期动画专题上线，收录宫崎骏全系列、迪士尼经典等百部动画电影。' },
  { date: '2026-07-25', label: '公告通知', text: '平台日活跃用户突破500万，感谢每一位支持6080新视觉影院的影迷朋友。' },
];

export default function UpdatesContactSection() {
  return (
    <>
      <section id="updates" className="relative w-full py-16 md:py-20 bg-background-100">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
              最新动态
            </h2>
            <p className="text-sm text-foreground-500">
              平台更新、资源上线与功能优化动态一览
            </p>
          </div>
          <div className="relative pl-6 md:pl-8 border-l border-background-200/60">
            {updates.map((item, idx) => (
              <div key={idx} className="relative pb-8 last:pb-0">
                <div className="absolute -left-[calc(1.5rem+3px)] md:-left-[calc(2rem+3px)] top-0.5 w-2.5 h-2.5 rounded-full bg-primary-500/60 border-2 border-background-100"></div>
                <div className="flex flex-wrap items-center gap-2 mb-1.5">
                  <span className="text-xs text-foreground-400">{item.date}</span>
                  <span className="px-2 py-0.5 text-[10px] font-medium bg-secondary-500/10 text-secondary-400 rounded-full whitespace-nowrap">
                    {item.label}
                  </span>
                </div>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {item.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="contact" className="relative w-full py-16 md:py-20 bg-background-50">
        <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-8 max-w-lg mx-auto">
            如果您在使用6080新视觉影院观看高清电影电视剧过程中遇到任何问题，或是有资源需求、合作意向、意见反馈，欢迎通过以下方式联系我们。
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
            <div className="bg-background-100 rounded-lg p-5 border border-background-200/40">
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-primary-500/10 mb-3">
                <i className="ri-mail-line text-lg text-primary-400"></i>
              </div>
              <p className="text-xs text-foreground-500 mb-1">商务合作</p>
              <p className="text-sm font-medium text-foreground-700">bd@6080ys.com</p>
            </div>
            <div className="bg-background-100 rounded-lg p-5 border border-background-200/40">
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-accent-500/10 mb-3">
                <i className="ri-customer-service-line text-lg text-accent-400"></i>
              </div>
              <p className="text-xs text-foreground-500 mb-1">用户反馈</p>
              <p className="text-sm font-medium text-foreground-700">support@6080ys.com</p>
            </div>
            <div className="bg-background-100 rounded-lg p-5 border border-background-200/40">
              <div className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-secondary-500/10 mb-3">
                <i className="ri-shake-hands-line text-lg text-secondary-400"></i>
              </div>
              <p className="text-xs text-foreground-500 mb-1">资源投稿</p>
              <p className="text-sm font-medium text-foreground-700">submit@6080ys.com</p>
            </div>
          </div>
          <p className="text-xs text-foreground-400">
            工作时间：周一至周日 9:00 - 22:00 · 通常48小时内回复
          </p>
        </div>
      </section>
    </>
  );
}